export class SearchCompanyReport {
  public companyName: string = '';
  public registerType: string = '';
}
